enum SectionType {
  DEFAULT,
  INVERT,
  DECENT,
  PROMINENT,
}

export default SectionType;
